module.exports = {
  no_access_tooltip: '{username} hat keinen Zugriff auf diesen Inhalt.',
  push_prompt: {
    enable: 'Aktivieren',
    failed_to_enable: 'Browser-Benachrichtigungen konnten nicht aktiviert werden',
    not_now: 'Nein',
    description: 'Lass dich über neue Nachrichten benachrichtigen, auch wenn du nicht auf dieser Seite bist.',
    title: 'Möchtest du bei neuen Nachrichten benachrichtigt werden?',
  },
  cancel: 'Abbrechen',
  attachment: 'Anhang',
  cancel_upload: 'Upload abbrechen',
  messages: 'Nachrichten',
  no_users_found: 'Keine Benutzer gefunden',
  search_chat: 'Chat durchsuchen',
  look_and_select_person_to_message: 'Such doch mal nach der Person, mit der du am liebsten arbeitest, und schreib ihr.',
  colleagues: 'Kollegen',
  delete_chat: {
    content: 'Bist du sicher, dass du diese Nachricht löschen möchtest?',
    confirm_deletion: 'Löschen',
    title: 'Chatnachricht löschen',
  },
  chat_empty_description: 'Nutze die Suche, um deinen ersten Chat zu starten!',
  message_context_menu: {
    delete: 'Nachricht löschen',
    reply: 'Antworten',
  },
  no_messages_found: 'Keine Nachrichten gefunden, die deinen Suchkriterien entsprechen.',
  users: 'User',
  you: 'Du',
  image: 'Bild',
  thread_has_no_messages_title: 'Das ist der Anfang deiner Direktnachrichten mit',
  media_empty_description: 'Wenn du Bilder, Videos, Dateien oder Links versendest, werden diese hier angezeigt.',
  chat_empty_title: 'Keine laufenden Chats',
  last_messages: 'Letzte Nachrichten ({count})',
  auto_translate_prompt: {
    not_now: 'Nicht jetzt',
    title: 'Nachrichten in diesem Chat immer übersetzen?',
    description: 'Eingehende Nachrichten automatisch in deine Sprache übersetzen.',
    enable: 'Immer übersetzen',
    failed_to_enable: 'Auto-Übersetzung konnte nicht aktiviert werden',
  },
  you_do_not_have_any_messages_yet: 'Du hast noch keine Nachrichten.',
  media_empty_title: 'Keine Medien hinzugefügt',
  write_a_message: 'Schreibe eine Nachricht...',
  uploading: 'Wird hochgeladen...',
  is_typing: 'tippt',
  translate: 'Übersetzen',
  auto_translate_toggle: {
    label: 'Nachrichten automatisch übersetzen',
    warning: 'KI-Übersetzungen können fehlerhaft oder irreführend sein. Bitte prüfe relevante Informationen mit {username}, wenn du KI-Übersetzungen verwendest.',
  },
  ai_translated_show_original: 'KI-Übersetzt (Original anzeigen)',
  send: 'Senden',
  thread_inactive: 'User {username} ist nicht mehr zum Chatten verfügbar.',
  reactions: {
    add: 'Reaktion hinzufügen',
    remove: 'Reaktion entfernen',
    picker_title: 'Reaktion hinzufügen',
  },
  deleted_message: 'Gelöschte Nachricht',
}
